import { fetchSwatches } from '../../services/swatches.service'
import { ActionTree } from 'vuex'
import { SwatchesState } from './swatches.types'
import { SearchParams } from '../../types'

export const actions: ActionTree<SwatchesState, unknown> = {
  async fetchSwatches({ commit }, params: SearchParams) {
    try {
      const res = await fetchSwatches(params)
      commit('SET_ALL_SWATCHES', res)
    } catch (err) {
      commit('SET_SWATCHES_LOADING_ERROR', err)
    }
  }
}
